import DailyNewUsers from './DailyNewUsers';
import DailyNewReferrals from './DailyNewReferrals';
import TotalUsers from './TotalUsers';
import LongPositions from './LongPositions';
import ClosedPositions from './ClosedPositions';
import OpenInterest from './OpenInterest';
import TotalProtocolFees from './TotalProtocolFees';
import TotalTrades from './TotalTrades';
import TotalTradingVolume from './TotalTradingVolume';
import TotalValueLocked from './TotalValueLocked';
import NewPositions from './NewPositions';
import DailyUsers from './DailyUsers';
import ShortPositions from './ShortPositions';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const Analytics = () => {
    // useAnalytics();
    useMockAnalytics();

    return (
        <section id='analytics'>
            <div className='container'>
                <div className='mini-card-container'>
                    <NewPositions />
                    <OpenInterest />
                    <ClosedPositions />
                    <LongPositions />
                    <DailyUsers />
                    <ShortPositions />
                    <TotalUsers />
                    <TotalTrades />
                </div>
                <div className='bar-charts-container'>
                    <DailyNewUsers />
                    <div className='bar-charts-divider' />
                    <DailyNewReferrals />
                </div>
                <TotalValueLocked />
                <TotalTradingVolume />
                <TotalProtocolFees />
            </div>
        </section>
    );
};

export default Analytics;
